var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExplodeDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03299 1.75C8.4472 1.75 8.78299 2.08579 8.78299 2.5V4.01666H15.2161V2.5C15.2161 2.08579 15.5519 1.75 15.9661 1.75C16.3804 1.75 16.7161 2.08579 16.7161 2.5V4.01666H19.3667C20.4068 4.01666 21.25 4.85985 21.25 5.89999V18.3667C21.25 19.4068 20.4068 20.25 19.3667 20.25H4.63333C3.5932 20.25 2.75 19.4068 2.75 18.3667V5.89999C2.75 4.85985 3.5932 4.01666 4.63333 4.01666H7.28299V2.5C7.28299 2.08579 7.61877 1.75 8.03299 1.75ZM7.28299 5.51666H4.63333C4.42162 5.51666 4.25 5.68828 4.25 5.89999V8.54997H19.75V5.89999C19.75 5.68828 19.5784 5.51666 19.3667 5.51666H16.7161V6.46667C16.7161 6.88088 16.3804 7.21667 15.9661 7.21667C15.5519 7.21667 15.2161 6.88088 15.2161 6.46667V5.51666H8.78299V6.46667C8.78299 6.88088 8.4472 7.21667 8.03299 7.21667C7.61877 7.21667 7.28299 6.88088 7.28299 6.46667V5.51666ZM19.75 10.05H4.25V18.3667C4.25 18.5784 4.42162 18.75 4.63333 18.75H19.3667C19.5784 18.75 19.75 18.5784 19.75 18.3667V10.05Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExplodeDate);
export default __webpack_public_path__ + "static/media/icon_explode-date.2cca5e83f2d82f96f935f2bd4282c11d.svg";
export { ForwardRef as ReactComponent };